module.exports = __webpack_public_path__ + "media/img/iphone_app@2x-98296969.png";